<template>
	<div>
		<q-btn-dropdown :label="$t(getCampaignLabel)" flat v-model="show_campaigns" v-if="reward_selection_campaigns.length > 0">
			<q-list link>
				<q-item v-for="(item, index) in campaignsList" :key="index" v-if="id_user_campaign_selected !== item.value" @click.native="changeCampaign(item)">
					<q-item-main>
						<q-item-tile label>{{ item.title }}</q-item-tile>
					</q-item-main>
				</q-item>
			</q-list>
		</q-btn-dropdown>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data(){
		return{
            show_campaigns: false,
		}
	},
	computed:{
		...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_campaign_selected: 'common/id_user_campaign_selected',
            id_user_client_country_selected: 'common/id_user_client_country_selected',
            id_user_client_selected: 'common/id_user_client_selected',
            id_user_language_selected: 'common/id_user_language_selected',
            reload_content: 'common/reload_content',
            reward_selection_campaigns: 'registration_lists/reward_selection_campaigns',
            user_clients: 'common/user_clients',
            user_countries: 'common/user_countries',
            user_module_items: 'common/user_module_items'
        }),

		getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
		},

		getCampaignLabel() {
			let obj = this.reward_selection_campaigns.find((obj) => { return obj.id === this.id_user_campaign_selected })
            if (obj) return obj.title
            else return 'select_a_campaign'
		},

        campaignsList() {
            return this.reward_selection_campaigns.map(e => ({
                ...e,
                value: e.id,
                label: e.title
            }))
        }
	},
	methods:{
		changeCampaign(item) {
            this.$store.dispatch('common/SET_CAMPAIGN', [item.id])
            this.show_campaigns = false
			this.setUserSelection()
		},

		setUserSelection() {
			this.$q.loading.show()
			let fd = new FormData()

			fd.append('client', this.id_user_client_selected)
			fd.append('country', this.id_user_client_country_selected)
			fd.append('language', this.id_user_language_selected)
			fd.append('campaign', this.id_user_campaign_selected)

			this.$axios.post('/accounts/set_user_selection/', fd, this.getHeader)
			.then(response => {
				this.getUserData()
			})
			.catch(e => {
				this.$q.loading.hide()
				console.log(e)
			})
		},

		getUserData() {
            this.$axios.get('/accounts/read_user_data/', this.getHeader)
            .then(response => {
				const d = response.data

                this.$store.dispatch('common/SET_USER_DATA', [
                    d.id, 
                    d.id_user_client_profile, 
                    d.full_name, 
                    d.document, 
                    d.id_user_client_selected, 
                    d.id_user_client_country_selected, 
                    d.id_user_language_selected, 
                    d.user_clients, 
                    d.user_client_module_items, 
                    d.user_modules, 
                    d.user_module_items, 
                    d.user_firebase_document, 
                    d.is_superuser, 
                    d.email, 
                    d.user_firebase_document_ranking_areas, 
                    d.has_mandatory_surveys, 
                    d.accept_terms_and_conditions, 
                    d.user_companies,
                    d.user_branches,
                    d.id_user_campaign_selected
                ])

				if (this.$route.name === 'admin_overview') this.$store.dispatch('common/SET_RELOAD_CONTENT', [!this.reload_content])
				else this.$router.replace({ name: 'admin_overview' })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
		}
	}
}
</script>

<style>
</style>
